export const onKeyDown = (e, cb) => {
    if (e.keyCode === 13) {
        cb(e);
    }
}